import { render, staticRenderFns } from "./addSeries.vue?vue&type=template&id=460a32ca"
import script from "./addSeries.vue?vue&type=script&lang=js"
export * from "./addSeries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports